/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'am_small_logo': {
    width: 16,
    height: 16,
    viewBox: '0 0 925.15 474.44',
    data: '<path pid="0" d="M430.57 0h4.89v474.44h-4.89zM164.36 286.79H50.28L5.12 402.26H0L128.51 75.4h2.33l125.25 326.86h-48.42l-43.31-115.47zM52.15 282.6H162.5l-53.54-142.47h-.93L52.15 282.6zM635.08 402.26V80.99h53.08l94.52 259.81h.93L875.8 80.99h49.36v321.27h-45.63V87.97h-.93L766.38 405.98h-4.19L641.13 87.04h-.93v315.22h-5.12z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/am_small_logo.js